"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return UserRefreshToken;
    }
});
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
const _constants = require("~/constants");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let UserRefreshToken = class UserRefreshToken {
    static async insert(userRefreshToken, ncMeta = _Noco.default.ncMeta) {
        // clear old invalid tokens before inserting new one
        await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USER_REFRESH_TOKENS, {
            fk_user_id: userRefreshToken.fk_user_id
        }, {
            expires_at: {
                lt: (0, _dayjs.default)().toDate()
            }
        });
        const insertObj = (0, _extractProps.extractProps)(userRefreshToken, [
            'fk_user_id',
            'token',
            'expires_at',
            'meta'
        ]);
        // set expiry based on the env or default value
        if (!('expires_at' in insertObj)) {
            insertObj.expires_at = (0, _dayjs.default)().add(_constants.NC_REFRESH_TOKEN_EXP_IN_DAYS, 'day').toDate();
        }
        if ('meta' in insertObj) {
            insertObj.meta = (0, _modelUtils.stringifyMetaProp)(insertObj);
        }
        await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USER_REFRESH_TOKENS, insertObj, true);
        return insertObj;
    }
    // todo: caching
    static async updateOldToken(oldToken, newToken, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USER_REFRESH_TOKENS, {
            token: newToken,
            expires_at: (0, _dayjs.default)().add(_constants.NC_REFRESH_TOKEN_EXP_IN_DAYS, 'day').toDate()
        }, {
            token: oldToken
        });
    }
    static async deleteToken(token, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USER_REFRESH_TOKENS, {
            token
        });
    }
    static async deleteAllUserToken(userId, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USER_REFRESH_TOKENS, {
            fk_user_id: userId
        });
    }
    static async getByToken(token, ncMeta = _Noco.default.ncMeta) {
        const userToken = await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USER_REFRESH_TOKENS, {
            token
        });
        if (!userToken) return null;
        userToken.meta = (0, _modelUtils.parseMetaProp)(userToken);
        return userToken;
    }
};
